import { Box, BoxProps, CircularProgress } from "@mui/material";
export type LoadingBoxProps = {
  loading?: boolean;
  loadingPosition?: "start" | "center" | "end";
} & BoxProps;
export function LoadingBox({ loading = false, loadingPosition = "start", children, ...others }: LoadingBoxProps) {
  return (
    <Box style={{ position: "relative" }} {...others}>
      {loading && (
        <div style={{ position: "absolute", left: 0, top: 0, height: "100%", width: "100%", zIndex: 100, display: "flex", justifyContent: "center", alignItems: loadingPosition }}>
          <img style={{ width: "100px", height: "100px" }} src="/loading.gif" />
        </div>
      )}
      {children}
    </Box>
  );
}
